import { SegmentDetailDto, SegmentEditDto } from './segment';

export const mapSegmentDetailToEdit = (
  dto: SegmentDetailDto
): SegmentEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  description: dto.description,
  markLabel: dto.markLabel,
  productTypeId: dto.productTypeId,
  segmentGrades: dto.segmentGrades
});
